import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "dashboard-card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Общая статистика по командам")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-flex pr-8 align-center fixed-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"48px"} }, null, -1)
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "d-flex align-center" }

import { useProgramsStore } from '@/stores/programs';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import VDiagram from '@/components/VDiagram.vue';
import VTable from '@/components/VTable.vue';
import VUserInfo from '@/components/VUserInfo.vue';
import { useUiStore } from '@/stores/ui';
import dayjs from 'dayjs';
import AnaliticsCell from '@/components/AnaliticsCell.vue';
import VLimitTag from '@/components/VLimitTag.vue';
import AnaliticsCellLimit from '@/components/AnaliticsCellLimit.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Analitics',
  setup(__props) {

const executionKeyColors = {
  6: "#6CCB86",
  5: "#C8EF75",
  4: "#EFEA75",
  3: "#EFC575",
  2: "#EF9A75",
  1: "#EF7575"
}

const router = useRouter()
const programsStore = useProgramsStore()

const program = computed(() => programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId))

watch(program, program => {
  if (!program) return
  programsStore.requestAnalitics(program)
}, { immediate: true })

const page = ref("execution")

const weekConstant = 1000 * 60 * 60 * 24 * 7
const weekStart = dayjs().day(1).startOf("day").unix() * 1000
const groupedReports = computed(() => {
  const reports = program.value?.analitics?.reports
  if (!reports || reports.length === 0) return []

  const weeks: any[][] = []
  let currentWeek: number | null = null
  let weeksArr: number[] = []
  for (let report of reports) {
    let week = Math.floor((Date.parse(report.date) - weekStart) / weekConstant)
    if(report.tmDate){
      week = Math.floor((Date.parse(report.tmDate) - weekStart) / weekConstant)
    }
    if (currentWeek === null || week > currentWeek) {
      weeks.push([])
      weeksArr.push(week)
      weeks[weeks.length-1].unshift(report)
      currentWeek = week
    } else if (week < currentWeek){
      const index = weeksArr.indexOf(week)
      if (index >= 0) {
        weeks[index].unshift(report)
      }
    }else if (week === currentWeek){
      weeks[weeks.length-1].unshift(report)
    }
    
  }
  return weeks
})

const groupedLimitReports = computed(() => {
  const limitReports = program.value?.analitics?.limits
  if (!limitReports || limitReports.length === 0) return []

  const months: any[][] = []
  let currentMonth: number | null = null
  for (let report of limitReports) {
    const month = dayjs(report.date).startOf("month").unix()
    if (currentMonth === null) {
      months.push([])
    } else if (month !== currentMonth) {
      months.push([])
    }
    months[months.length-1].unshift(report)
    currentMonth = month
  }
  return months
})

const _tm = (i: number) => "tm"+(i+1)

const columns = computed(() => {
  return {
    name: { title: "Название команды", width: 220, class: "fixed-column", thClass: "fixed-column" },
    tracker: { title: "Трекер", width: 170, class: "fixed-column", thClass: "fixed-column" },
    ceoId: { title: "CEO", width: 170 },
    keyLimit: { title: "Ключевое ограничение", width: 160, class: "border-right limit-cell", fallback: "-" },
    ...Object.fromEntries(groupedReports.value.map((item, index) => [
      _tm(index), { 
        title: "TM"+(index+1), 
        class: "report-cell", 
        thClass: "report-cell", 
        width: 60,
        tooltip: dayjs(item[0].tmDate || item[0].date).startOf("week").format("DD MMM") + " - " + dayjs(item[0].tmDate || item[0].date).endOf("week").format("DD MMM")
      },
    ])),
    empty: { title: "" }
  }
})

const limitColumns = computed(() => {
  return {
    name: { title: "Название команды", width: 220 },
    tracker: { title: "Трекер", width: 200 },
    ...Object.fromEntries(groupedLimitReports.value.map((item, index) => [
      _tm(index), { title: dayjs(item[0].date).format("MMMM"), class: "limit-cell", thClass: "limit-cell", width: 160 },
    ])),
    empty: { title: "" }
  }
})

const uiStore = useUiStore()
const openTeam = (team: any) => {
  uiStore.team = team
}

const scoreItems = [ { value: "both", title: "Execution/Дневник" }, { value: "execution", title: "Execution" }, { value: "diary", title: "Дневник" } ]
const score = ref("both")

const teamLimits = computed(() => {
  const obj: any = {}
  for (let item of (program.value?.analitics?.limits || [])) {
    const arr = obj[item.teamId] || []
    arr.push(item)
    obj[item.teamId] = arr
  }
  return obj
})

const colors: any = {
  "Цели": "#5761E3",
  "Возможность": "#EF9275",
  "Востребованность": "#A557E3",
  "Реализуемость": "#D857E3",
  "Жизнеспособность": "#1EC776",
  "Адаптируемость": "#35BEE9",
}

const analiticsItems = computed(() => {
  const arr: { title: string, value: number, color: string }[] = []
  for (let [ _,teamLimit ] of Object.entries<any>(teamLimits.value)) {
    const key = teamLimit[teamLimit.length-1].keyLimit
    if (!key) continue
    const item = arr.find(item => item.title === key)
    if (!item) {
      arr.push({ title: key, value: 1, color: colors[key] })
    } else {
      item.value++
    }
  }
  return arr
})

const onScroll = (e: Event) => {
  const target = e.target as HTMLElement

  const style = `translateX(${target.scrollLeft}px)`
  for (let column of target.querySelectorAll<HTMLDivElement>(".fixed-column")) {
    column.style.transform = style
  }

}


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(VDiagram, {
          items: _unref(analiticsItems),
          label: "Ограничения"
        }, null, 8, ["items"]),
        _createVNode(VDiagram, {
          items: _unref(program)?.analitics?.execution,
          label: "Execution",
          "key-colors": executionKeyColors,
          style: {"flex-grow":"0.5","min-width":"370px"}
        }, null, 8, ["items"])
      ])
    ]),
    _createElementVNode("div", {
      class: "dashboard-card pt-3 px-0",
      onScroll: onScroll
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_tabs, {
          color: "primary",
          modelValue: page.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
          class: "px-8 mr-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "execution" }, {
              default: _withCtx(() => [
                _createTextVNode("Execution")
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "limits" }, {
              default: _withCtx(() => [
                _createTextVNode("Ограничения")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_select, {
          modelValue: score.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((score).value = $event)),
          items: scoreItems,
          variant: "outlined",
          class: "v-select-min",
          label: "Оценка"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_6,
      (page.value === 'execution')
        ? (_openBlock(), _createBlock(VTable, {
            key: 0,
            columns: _unref(columns),
            data: _unref(program)?.teams || [],
            onOnitemclick: openTeam
          }, _createSlots({
            ceoId: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(VUserInfo, {
                  user: _unref(program)?.students?.find((student) => student.id === item.ceoId)
                }, null, 8, ["user"])
              ])
            ]),
            tracker: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(VUserInfo, {
                  "user-id": item.trackerId
                }, null, 8, ["user-id"])
              ])
            ]),
            keyLimit: _withCtx(({ item }) => [
              (_unref(teamLimits)[item.id]?.length > 0)
                ? (_openBlock(), _createBlock(AnaliticsCellLimit, {
                    key: 0,
                    report: _unref(teamLimits)[item.id][_unref(teamLimits)[item.id].length-1],
                    "team-id": item.id
                  }, null, 8, ["report", "team-id"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            _renderList(_unref(groupedReports), (group, index) => {
              return {
                name: _tm(index),
                fn: _withCtx(({ item }) => [
                  (_openBlock(), _createBlock(AnaliticsCell, {
                    program: _unref(program),
                    groupReport: group,
                    teamId: item.id,
                    key: item.id,
                    "show-miss": (group[0] && (weekStart - Date.parse(group[0].date)) > 0) || (group[0] && (weekStart - Date.parse(group[0].tmDate)) > 0),
                    mode: score.value
                  }, null, 8, ["program", "groupReport", "teamId", "show-miss", "mode"]))
                ])
              }
            })
          ]), 1032, ["columns", "data"]))
        : (page.value === 'limits')
          ? (_openBlock(), _createBlock(VTable, {
              key: 1,
              columns: _unref(limitColumns),
              data: _unref(program)?.teams || [],
              onOnitemclick: openTeam
            }, _createSlots({
              tracker: _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(VUserInfo, {
                    "user-id": item.trackerId
                  }, null, 8, ["user-id"])
                ])
              ]),
              _: 2
            }, [
              _renderList(_unref(groupedLimitReports), (group, index) => {
                return {
                  name: _tm(index),
                  fn: _withCtx(({ item }) => [
                    (_openBlock(), _createBlock(AnaliticsCellLimit, {
                      groupReport: group,
                      teamId: item.id,
                      key: item.id
                    }, null, 8, ["groupReport", "teamId"]))
                  ])
                }
              })
            ]), 1032, ["columns", "data"]))
          : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})